import styled, { css } from 'styled-components';
import {
  mq,
  getTextType,
  getSpace,
  getGridSpan,
  px2rem,
  getGridSpans
} from '../../../stylesheets/tools';

const StyledMixedCopy = styled.div`
  margin: 0 auto;

  p {
    ${getGridSpans('width', { s: 11, m: 9 })}
    margin: ${getSpace('m')} ${getGridSpan('1', 'spread')};
    font-weight: 400;
    padding: 0;

    ${mq('m')} {
      margin: ${getSpace('m')} ${getGridSpan('2', 'spread')};
    }
    
    ${mq('l')} {
      &.two-column  {
        column-count: 2;
        column-gap: 25px;
      }
    }

    &.align-right {
      ${getGridSpans('width', { s: 10, m: 9 })}
      ${getGridSpans('margin-left', { s: [2, 'spread'], m: [3, 'spread'] })}
      ${getGridSpans('margin-right', { s: 0, m: 0 })}
    }

    &.align-left {
      ${getGridSpans('margin-right', { s: [2, 'spread'], m: [3, 'spread'] })}
      ${getGridSpans('margin-left', { s: 0, m: 0 })}
    }

    ${props =>
      props.fullWidth &&
      css`
        width: 100%;
        margin: 0;

        ${mq('m')} {
          width: 100%;
          margin: 0;
        }
      `}
  }

  h2 {
    ${getTextType('secondary')}
    margin: ${getSpace('s')} 0 ${getSpace('l')};

    ${mq('m')} {
      margin: ${getSpace('s')} 0 ${getSpace('l')} ${getGridSpan('1', 'spread')};
    }

    [data-whatinput='mouse'] &,
    [data-whatinput='touch'] & {
      outline: 0;
    }
  }

  h3 {
    ${getTextType('subline')}
    margin: ${getSpace('l')} 0 ${getSpace('s')};

    ${mq('m')} {
      margin: ${getSpace('l')} 0 ${getSpace('s')} ${getGridSpan('1', 'spread')};
    }
  }

  h2,
  h3 {
    ${getGridSpans('width', { s: 11, m: 7 })}
    text-transform: uppercase;
    color: black;
    font-weight: normal;

    &:first-of-type {
      margin-left: ${getGridSpan('1', 'spread')};
    }

  }

  ul,
  ol {
    ${getGridSpans('width', { s: 11, m: 9 })}
    margin: ${getSpace('m')} ${getGridSpan('1', 'spread')};
    padding: 0;
    list-style-position: inside;

    ${mq('m')} {
      margin: ${getSpace('m')} ${getGridSpan('2', 'spread')};
    }
  }

  ul {
    list-style-type: none;

    li {
      position: relative;
      margin-left: 15px;

      &:before {
        position: absolute;
        content: '';
        left: ${px2rem('-15px')};
        width: ${px2rem('7px')};
        height: ${px2rem('7px')};
        border-radius: 100%;
        background: black;
        top: 10px;
      }
    }
  }

  a {
    border-bottom: 1px solid black;
    color: black;
    text-decoration: none;

    &[target='_blank'] {
      margin-right: 2px;

      &:after {
        position: relative;
        content: '';
        display: inline-block;
        background-image: url("data:image/svg+xml,%3Csvg width='15' height='15' viewBox='0 0 15 15' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M11.514 2.2H6.786a1 1 0 1 1 0-2h7a1 1 0 0 1 1 1v7a1 1 0 1 1-2 0V3.756L1.907 14.635a1 1 0 0 1-1.414-1.414L11.513 2.2z'/%3E%3C/svg%3E");
        height: 0.625rem;
        width: 0.625rem;
        background-size: 0.625rem 0.625rem;
        margin-left: 5px;
        margin-bottom: 1px;
      }
    }

    &.disabled {
      margin-right: 0;
      pointer-events: none;
      border-bottom: none;

      &:after {
        display: none;
        background-image: none;
        height: 0;
        width: 0;
      }
    }
  }

  p, ul, ol {
    ${getTextType('copy', 'international')}

    ${props =>
      props.focused &&
      css`
        ${getTextType('copyFocused', 'international')}
      `} 

    ${props =>
      props.thick &&
      css`
        ${getTextType('copy', 'international')}
        font-weight: 700;
      `}

    ${props =>
      props.small &&
      css`
        ${getTextType('copySmall', 'international')}
      `}

    ${props =>
      props.smallThick &&
      css`
        ${getTextType('copySmall', 'international')}
        font-weight: 700
      `}

    ${props =>
      props.extraSmall &&
      css`
        ${getTextType('copyExtraSmall', 'international')}
      `}
    }

`;

export default StyledMixedCopy;
